import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { theme } from "./hoc/Theme";
import { usePageTitle } from "./hoc/Hooks";
import CustomScrollbars from "./CustomScrollbars";
import Footer from "./Footer";
import Header from "./Header";
import { APP_NAME } from "config";
import { useClientViewContext } from "contexts/ClientViewContext";

type LayoutProps = {
  title?: string;
  content?: string;
  noScroll?: boolean;
};

const Layout = ({
  title,
  content,
  children,
  noScroll = false,
}: React.PropsWithChildren<LayoutProps>) => {
  usePageTitle(`${APP_NAME} | ` + (title || ""));
  const inClientView = useClientViewContext();

  if (inClientView) {
    return <>{children}</>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: "100vh",
          minHeight: 0,
          maxHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flex: "1 1 0",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Header>
            {noScroll ? (
              <Box
                component="main"
                sx={{
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                {children}
              </Box>
            ) : (
              <Box
                component="main"
                sx={{
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CustomScrollbars sx={{ flex: 1, minHeight: 0 }}>
                  {children}
                </CustomScrollbars>
              </Box>
            )}
          </Header>
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
